








import { Component, Prop, Vue } from "vue-property-decorator";
// @ts-ignore
import { SimpleDropzone } from "simple-dropzone";

interface FileEvent {
  files: Map<string, File>;
}

@Component
export default class DropImage extends Vue {
  @Prop() private name!: string;
  @Prop() private callback!: (imageData: ImageData) => void;
  private imageDropzone: SimpleDropzone | undefined;

  mounted() {
    const dropzone = this.$el.querySelector<HTMLElement>(".dropzone");
    const input = this.$el.querySelector<HTMLInputElement>(".input");

    this.imageDropzone = new SimpleDropzone(dropzone, input);
    this.imageDropzone.on("drop", (result: FileEvent) =>
      this.load(result.files)
    );
  }

  load(fileMap: Map<string, File>) {
    let rootFile: File | undefined;

    Array.from(fileMap).forEach(([, file]) => {
      rootFile = file;
    });

    if (!rootFile) {
      // tslint:disable-next-line no-console
      console.error("No file found.");
    }

    const reader = new FileReader();
    reader.onload = () => {
      const image = new Image();
      image.src = reader.result as string;
      image.onload = () => {
        this.callback(this.getImageData(image) as ImageData);
      };
    };
    reader.readAsDataURL(rootFile as File);
  }

  getImageData(image: HTMLImageElement): ImageData | null {
    const canvas = this.$el.querySelector(".image") as HTMLCanvasElement;
    const canvasContext = canvas.getContext("2d");

    if (!canvasContext) {
      return null;
    }

    const imgW = image.width;
    const imgH = image.height;
    canvas.width = imgW;
    canvas.height = imgH;

    canvasContext.drawImage(image, 0, 0);
    const imgPixels = canvasContext.getImageData(0, 0, imgW, imgH);

    return imgPixels;
  }
}
